import { getCookie, setCookie } from "./helpers";
import {
  ContactServiceState,
  ContactServiceTypes,
  ContactServiceAction,
} from "./types";

const initialState: ContactServiceState = {
  purchaseDetails: {
    invoice: "",
    date_of_purchase: "",
    store_name: "",
    store_phone: "",
    store_address: "",
    store_city: "",
    store_state: "",
    were_any_items_exchanged: "",
    store_zip: "",
  },
  customerDetails: {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
  },
  documents: {
    invoice: [],
  },
  ...JSON.parse(getCookie("data") || "{}"),
};

export const contactServiceReducer = (
  state: ContactServiceState = initialState,
  action: ContactServiceTypes
): ContactServiceState => {
  switch (action.type) {
    case ContactServiceAction.UPDATE_STATE: {
      const mappedState = Object.keys(action?.payload || {}).reduce(
        (acc, key) => {
          acc[key] = action.payload[key];
          return acc;
        },
        {}
      );
      setCookie("data", { ...state, ...mappedState }, { parseJson: true });
      return { ...state, ...mappedState };
    }

    case ContactServiceAction.CLEAN_UP: {
      return {
        purchaseDetails: {
          invoice: "",
          date_of_purchase: "",
          store_name: "",
          store_phone: "",
          store_address: "",
          store_city: "",
          store_state: "",
          were_any_items_exchanged: "",
          store_zip: "",
        },
        customerDetails: {
          name: "",
          email: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          zip_code: "",
        },
        documents: {
          invoice: [],
        },
      };
    }

    default:
      return state;
  }
};
